import Api from "@/repository/api";
import { ResponseDataType } from "@/form/form.types";
import { DocumentRequestType, IDocuments } from "@/entity/documents/documents.types";
import { IDocumentsRepository } from "@/repository/documents/DocumentsRepository.types";

export class DocumentsRepository implements IDocumentsRepository {
    async fetchAll(data?: FormData): Promise<IDocuments> {
        const response = await Api.get(`/clients/documents/get`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString();
            },
        });
        console.error(response)
        return response.data as IDocuments;
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const resp = await Api.post('/clients/documents/delete', data);
        return resp.data;
    }
    async save(data: DocumentRequestType): Promise<ResponseDataType> {
        const resp = await Api.post('/clients/documents/save', data);
        return resp.data;
    }
}